import {
  IAlspSolutionDataFragment,
  IConsultancySolutionDataFragment,
  IEnum_Solution_Producttype,
  IEnum_Solution_Type,
  IProductSolutionDataFragment,
} from 'src/graphql/generated/hooks'

export type SolutionDataFragment =
  | IAlspSolutionDataFragment
  | IConsultancySolutionDataFragment
  | IProductSolutionDataFragment

export const isProductSolution = (solution: SolutionDataFragment): solution is IProductSolutionDataFragment =>
  solution.attributes?.type === IEnum_Solution_Type.Product

export const isAlspSolution = (solution: SolutionDataFragment): solution is IAlspSolutionDataFragment =>
  solution.attributes?.type === IEnum_Solution_Type.Alsp

export const isConsultancySolution = (solution: SolutionDataFragment): solution is IConsultancySolutionDataFragment =>
  solution.attributes?.type === IEnum_Solution_Type.Consultancy

export const isGraveyardProductSolution = (solution: SolutionDataFragment): solution is IProductSolutionDataFragment =>
  isProductSolution(solution) &&
  solution.attributes?.productType === IEnum_Solution_Producttype.Graveyard &&
  !!solution.attributes?.graveyardData

export const isConsolidationProductSolution = (
  solution: SolutionDataFragment,
): solution is IProductSolutionDataFragment =>
  isProductSolution(solution) &&
  solution.attributes?.productType === IEnum_Solution_Producttype.Consolidation &&
  !!solution.attributes?.consolidationData
